import context from "../../audioContext";

export default function decodeAudioBuffer(arrayBuffer) {
	return context.decodeAudioData(arrayBuffer);
}
